import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'Plain';
        src: url('https://pblx.s3.amazonaws.com/pnl/fonts/PlainRegular.woff'); 
        font-style: normal;
        font-weight: 400;
        text-rendering: optimizeLegibility;
    }

    @font-face {
        font-family: 'Plain';
        src: url('https://pblx.s3.amazonaws.com/pnl/fonts/PlainBold.woff'); 
        font-style: normal;
        font-weight: 700;
        text-rendering: optimizeLegibility;
    }

    body {
        font-family: 'Plain', sans-serif;
    }
`;
